import { Sparkles } from "lucide-react";

/**
 * AI captions side-panel — textarea + "AI captions" generator button.
 */
export default function CaptionsPanel({ captions, onChange, onGenerate, busy }) {
  return (
    <div className="glass rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Sparkles size={16} className="text-[#F5C542]" />
        <div className="font-display font-bold">Captions</div>
      </div>
      <textarea
        data-testid="captions-input"
        value={captions}
        onChange={(e) => onChange(e.target.value)}
        placeholder="On-screen caption"
        rows={3}
        className="nexus-input resize-none"
      />
      <button
        data-testid="ai-captions"
        onClick={onGenerate}
        disabled={busy}
        className="mt-2 nexus-btn-secondary text-xs flex items-center gap-2"
      >
        <Sparkles size={12} /> {busy ? "Writing…" : "AI captions"}
      </button>
    </div>
  );
}
